import { render, staticRenderFns } from "./DepartureData.vue?vue&type=template&id=dcfc0980&"
import script from "./DepartureData.vue?vue&type=script&lang=js&"
export * from "./DepartureData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports